export const containsAsync = async (source, value, comparer) => {
    for (const item of source) {
        if (await comparer(value, item)) {
            return true;
        }
    }
    return false;
};
